import React from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../Auth/useUser";

const WaiterRoute = ({ children }) => {
  const user = useUser();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return user.result.role === 'waiter' ? children : <Navigate to="/login" replace />;
};

export default WaiterRoute;